<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="40">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-light.svg" alt="" height="50">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-light.png" alt="" height="50">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>
      
      <!-- App Search-->



    </div>

    <div class="d-flex">

      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" data-toggle="dropdown"
          aria-haspopup="true" ngbDropdownToggle aria-expanded="false">
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-search-dropdown">

          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
         <div class="dropdown d-inline-block" ngbDropdown>
  
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <span class="d-none d-xl-inline-block ms-1">{{birimadi}}</span>
        </button>
       
      </div>
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <span class="d-none d-xl-inline-block ms-1">{{yetkili_isim}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
        
           <a class="dropdown-item" href="javascript: void(0);" (click)="sifremodal()"><i
              class="bx bx-lock-open font-size-16 align-middle me-1"></i>
            Şifre Değiştir</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Çıkış Yap</a>
        </div>
      </div>



    </div>
  </div>
</header>
<ng-template #sifre_modal let-modal>
  <div class="modal-header">
    <h5>Şifre Değiştir</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Close click')">
      </button>
    </div>
  <div class="modal-body ">
      <div class="row">
          <div class="col-md-12">
              <div class="card">
                  <div class="card-body "> 
                    <div class="row">
                      <div class="col-md-12">
                          <div class="mb-3">
                              <label for="formrow-firstname-input">Mevcut Şifreniz</label>
                              <input type="password" class="form-control" [(ngModel)]="mevcut">
                          </div>
                      </div>
                     </div>
                     <div class="row">
                      <div class="col-md-12">
                          <div class="mb-3">
                              <label for="formrow-firstname-input">Yeni Şifreniz</label>
                              <input type="password" class="form-control" [(ngModel)]="sifre">
                          </div>
                      </div>
                     </div>
                     <div class="row">
                      <div class="col-md-12">
                          <div class="mb-3">
                              <label for="formrow-firstname-input">Yeni Şifreniz (Tekrar)</label>
                              <input type="password" class="form-control" [(ngModel)]="sifre_tekrar">
                          </div>
                      </div>
                     </div>
                  </div>
              </div>
          </div>
      </div>
   
        <div class="modal-footer">
          <div class="btn-group" role="group" aria-label="Basic example">
              <button type="button" class="btn btn-primary" (click)="sifre_degistir()"> Gönder</button>
             
            </div>

        </div>
  </div>
</ng-template>